<template>
  <div class="block" v-if="images && images.ImageList">
    <div class="block__header">
      <images-list-toolbar @selectAll="$broadcast('select-item')" :selected-resolution.sync="selectedResolution" :resolutions="images.AvailableResolutions" :items-count="imageList.length"></images-list-toolbar>
      <h2 class="block__title">{{title}}</h2>
    </div>
    <div class="block__content">
      <ul class="image-list">
        <images-list-item v-for="image in imageList" track-by="Id" :image="image" :selected-resolution="selectedResolution" :resolutions="image.AvailableResolutions"></images-list-item>
      </ul>
    </div>
    <paginator :per-page="[8,12,16,20]" :items-count="images.ImageList.length" v-on:pagechange="paginatorChanged"></paginator>
  </div>
</template>

<script>
  import ImagesListItem from "./ImagesListItem";
  import ImagesListToolbar from "./ImagesListToolbar";
  import Paginator from "../../shared/Paginator";
  import Vue from "vue";

  import { downloadImages, basketImages, mailImages } from "./ImagesActions";

  export default {
    props: ["images", "title"],
    components: { ImagesListItem, Paginator, ImagesListToolbar },
    vuex: {
      getters: {
        selectedImages: state => state.selectedImages
      },
      actions: { downloadImages, basketImages, mailImages }
    },
    data: function () {
      return {
        imageList: [],
        selectedResolution: 72
      };
    },
    methods: {
      paginatorChanged (page, itemsPerPage) {
        var start = page * itemsPerPage;
        var end = start + itemsPerPage;
        this.imageList = (this.images.ImageList) ? Vue.util.extend([], this.images.ImageList.slice(start, end)) : [];
      }
    },
    watch: {
      "images.ImageList": function (value) {
        this.$broadcast("paginator-update");
      }
    }
  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .images{
    max-width: 1120px;
    margin: 100px auto;
    background: $brown_light;
  }

  .image-list{
    @include clear-fix;
    @include row(20px);
    list-style: none;
  }
  
</style>



// WEBPACK FOOTER //
// ImagesList.vue?4f18aacd